import { render, staticRenderFns } from "./MedicationListComponent.vue?vue&type=template&id=09021c07"
import script from "./MedicationListComponent.vue?vue&type=script&lang=js"
export * from "./MedicationListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports